import C from '../../../constants';

export const listings = (state = {}, action) => {
    switch (action.type) {
        case C.SET_LISTING:
            let newProperty = {};
            newProperty[action.payload.apply_key] = action.payload;
            return Object.assign({}, state, newProperty);

        case C.SET_LISTING_STATUS:
            let newPropertyB = {};
            newPropertyB[action.payload.apply_key] = {...state[action.payload.apply_key], ...action.payload.status};
            return Object.assign({}, state, newPropertyB);

        case C.SET_LISTING_AVAILABILITY:
            let newPropertyC = {};
            newPropertyC[action.payload.apply_key] = {...state[action.payload.apply_key], availability: action.payload.availability};
            return Object.assign({}, state, newPropertyC);

        case C.SET_LISTINGS:
            let newProperties = {};
            action.payload.forEach((property) => {
                newProperties[property.apply_key] = property;
            });
            return Object.assign({}, state, newProperties);

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/containers/listings/reducers/listingsReducer.js